export default __webpack_public_path__ + "static/media/palette.3dd7adb7.svg";